export enum SiteOptions {
  SITE_DESCRIPTION = "SITE_DESCRIPTION",
}

export const siteOptionsSchema: Record<SiteOptions, { displayName: string }> = {
  [SiteOptions.SITE_DESCRIPTION]: {
    displayName: "Site Description",
  },
};
